import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import PriceChangeViewV2 from 'components/Common/PriceChangeView/PriceChangeViewV2'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  reason: 'property-fees' | 'upgrade-margin'
  oldDisplayPrice: number
  newDisplayPrice: number
  oldPropertyFees: number
  newPropertyFees: number
}

function PropertyLoyaltyUpgradeUnavailableModal({
  reason,
  oldDisplayPrice,
  newDisplayPrice,
  oldPropertyFees,
  newPropertyFees,
}: Props) {
  const intl = useIntl()
  const { resolve } = useModalElementContext<boolean | undefined>()
  const continueWithoutUpgrade = useCallback(() => resolve(true), [resolve])
  const message = reason === 'property-fees'
    ? intl.formatMessage({
        id: 'lpeugOSwa7k0XMlwzuNw',
        defaultMessage: 'The property fees changed before we could secure your stay, so your package upgrade can’t be applied. You can continue at the updated total or choose another package. Your upgrade hasn’t been used.',
      })
    : intl.formatMessage({
        id: 'IxP6o_cz3cmKEGNNFRlL',
        defaultMessage: 'Your package upgrade can’t be applied to this booking. You can continue with this package at its current price or choose another package. Your upgrade hasn’t been used.',
      })

  return <ModalBase size="S">
    <ModalHeader title={intl.formatMessage({
      id: 'MWNU1bhJDwHNC0k0obdN',
      defaultMessage: 'Your package upgrade is no longer available',
    })}
    />
    <ModalBody>
      <ModalContent>
        <VerticalSpacer gap={24}>
          <BodyText as="p" variant="large">
            {message}
          </BodyText>
          <PriceChangeViewV2
            oldPrice={oldDisplayPrice}
            newPrice={newDisplayPrice}
            oldPropertyFees={oldPropertyFees}
            newPropertyFees={newPropertyFees}
          />
        </VerticalSpacer>
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={{
        children: intl.formatMessage({
          id: 'MLg7g98SmCIW0evmvjpT',
          defaultMessage: 'Continue without upgrade',
        }),
        onClick: continueWithoutUpgrade,
      }}
      secondaryActionProps={{
        children: intl.formatMessage({
          id: 'y1Ql2_MMZ062WQMQezuX',
          defaultMessage: 'Choose another package',
        }),
      }}
    />
  </ModalBase>
}

export default PropertyLoyaltyUpgradeUnavailableModal
